// DTG: 0 - no print, 4 - CMYK, 1 - single color,
// Embroidery - emb
export enum BasePrintAreaCode {
  None = '0-0',
  Front = '4-0',
  Back = '0-4',
  Both = '4-4',
  FrontEmbroidery = '4-0-emb',
  BackEmbroidery = '0-4-emb',
  BothEmbroidery = '4-4-emb',
  ChestLeftEmbroidery = 'chstl-emb',
  ChestCenterEmbroidery = 'chstc-emb',
  ChestLargeEmbroidery = 'chstlg-emb',
  LeftEmbroidery = 'left-emb',
  RightEmbroidery = 'right-emb',
  BackLargeEmbroidery = 'backlg-emb',
  RightCornerEmbroidery = 'rightcr-emb',
  LargeRightCornerEmbroidery = 'rightcrlg-emb',
  BottomCenterEmbroidery = 'ctbtmlg-emb',
}

export enum ApparelExtraPrintAreaCodeDtg {
  ShortSleeveLeft = 'shsll',
  ShortSleeveRight = 'shslr',
  InnerLabel = 'inlbl',
  BackLabel = 'bcklbl',
}

export enum ApparelExtraPrintAreaCodeEmbroidery {
  ShortSleeveLeft = 'shsll-emb',
  ShortSleeveRight = 'shslr-emb',
  WristLeft = 'wrstl-emb',
  WristRight = 'wrstr-emb',
}

// Both DTG and Embroidery
export const apparelExtraPrintAreaCodes = [
  ...Object.values(ApparelExtraPrintAreaCodeDtg),
  ...Object.values(ApparelExtraPrintAreaCodeEmbroidery),
];

export type ApparelExtraPrintAreaCode = ApparelExtraPrintAreaCodeDtg | ApparelExtraPrintAreaCodeEmbroidery;

// Some embroidery sides are not available for some products
export const baseApparelAndAccessoriesPrintAreaCodes = {
  priceList: [
    BasePrintAreaCode.Front,
    BasePrintAreaCode.ChestLeftEmbroidery,
    BasePrintAreaCode.ChestCenterEmbroidery,
    BasePrintAreaCode.ChestLargeEmbroidery,
    BasePrintAreaCode.FrontEmbroidery,
    BasePrintAreaCode.BackEmbroidery,
    BasePrintAreaCode.BothEmbroidery,
    BasePrintAreaCode.LeftEmbroidery,
    BasePrintAreaCode.RightEmbroidery,
    BasePrintAreaCode.BackLargeEmbroidery,
    BasePrintAreaCode.RightCornerEmbroidery,
    BasePrintAreaCode.LargeRightCornerEmbroidery,
    BasePrintAreaCode.BottomCenterEmbroidery,
  ],
  designEditor: [
    BasePrintAreaCode.Both,
    BasePrintAreaCode.ChestLargeEmbroidery,
    BasePrintAreaCode.ChestCenterEmbroidery,
    BasePrintAreaCode.ChestLeftEmbroidery,
    BasePrintAreaCode.FrontEmbroidery,
    BasePrintAreaCode.BackEmbroidery,
    BasePrintAreaCode.BothEmbroidery,
    BasePrintAreaCode.LeftEmbroidery,
    BasePrintAreaCode.RightEmbroidery,
    BasePrintAreaCode.BackLargeEmbroidery,
    BasePrintAreaCode.RightCornerEmbroidery,
    BasePrintAreaCode.LargeRightCornerEmbroidery,
    BasePrintAreaCode.BottomCenterEmbroidery,
  ],
};

export const basePrintAreaCodesEmbroidery = [
  BasePrintAreaCode.ChestLargeEmbroidery,
  BasePrintAreaCode.ChestCenterEmbroidery,
  BasePrintAreaCode.ChestLeftEmbroidery,
  BasePrintAreaCode.FrontEmbroidery,
  BasePrintAreaCode.BackEmbroidery,
  BasePrintAreaCode.BothEmbroidery,
  BasePrintAreaCode.LeftEmbroidery,
  BasePrintAreaCode.RightEmbroidery,
  BasePrintAreaCode.BackLargeEmbroidery,
  BasePrintAreaCode.RightCornerEmbroidery,
  BasePrintAreaCode.LargeRightCornerEmbroidery,
  BasePrintAreaCode.BottomCenterEmbroidery,
];

export const printAreaCodesSorted = [
  BasePrintAreaCode.Both,
  BasePrintAreaCode.Front,
  BasePrintAreaCode.Back,
  BasePrintAreaCode.ChestLargeEmbroidery,
  BasePrintAreaCode.ChestLeftEmbroidery,
  BasePrintAreaCode.ChestCenterEmbroidery,
  BasePrintAreaCode.FrontEmbroidery,
  BasePrintAreaCode.BackEmbroidery,
  BasePrintAreaCode.BothEmbroidery,
  BasePrintAreaCode.LeftEmbroidery,
  BasePrintAreaCode.RightEmbroidery,
  BasePrintAreaCode.BackLargeEmbroidery,
  BasePrintAreaCode.RightCornerEmbroidery,
  BasePrintAreaCode.LargeRightCornerEmbroidery,
  BasePrintAreaCode.BottomCenterEmbroidery,
];

export const printAreaCodesSortedByPrice = [
  BasePrintAreaCode.Front,
  BasePrintAreaCode.Back,
  BasePrintAreaCode.Both,
  BasePrintAreaCode.ChestLeftEmbroidery,
  BasePrintAreaCode.ChestCenterEmbroidery,
  BasePrintAreaCode.ChestLargeEmbroidery,
  BasePrintAreaCode.FrontEmbroidery,
  BasePrintAreaCode.BackEmbroidery,
  BasePrintAreaCode.BothEmbroidery,
  BasePrintAreaCode.LeftEmbroidery,
  BasePrintAreaCode.RightEmbroidery,
  BasePrintAreaCode.BackLargeEmbroidery,
  BasePrintAreaCode.RightCornerEmbroidery,
  BasePrintAreaCode.LargeRightCornerEmbroidery,
  BasePrintAreaCode.BottomCenterEmbroidery,
];
